export default {
	UPDATE_USER: 'users/update',
	CHATS: {
		MESSAGE: 'chats/message',
		REJECTED: 'chats/rejected',
	},
	CONSULTATION_REQUEST: {
		NEW: 'consultation_request/new',
		ACCEPTED: 'consultation_request/accepted',
		REJECTED: 'consultation_request/rejected',
		FINISHED: 'consultation_request/finished',
		ROOM: {
			JOIN: 'appointment/room/join',
			LEAVE: 'appointment/room/leave',
			HOST_JOINED: 'appointment/room/host_joined',
			HOST_LEFT: 'appointment/room/host_left',
			DISCONNECTED: 'appointment/room/disconnected',
		},
	},
}